import axios from 'axios'

class SuggestionMessagesService {
    async submit(message:string, action:string){
        try {
            const { data } = await axios.post(
                '/operator/v4/suggestion-message',
                {
                    message: message,
                    context: action
                }
            )

            return data.message ?? ''
        } catch (error) {
            console.error('❌ Erro ao apagar mensagem agendada', error)
            return []
        }
    }
}

export default new SuggestionMessagesService()
